module.exports = __webpack_public_path__ + "assets/img/logitech-astrogaming.4573b6ae.webp";